module.exports = __webpack_public_path__ + "static/media/advasonic-logo.cdf5a3e3.png";